import * as React from "react";
import { Layout } from 'antd';
import GameSideNav from "./GameSideNav";
import '../Layout.less';
import GeneralHeader from "src/layouts/GeneralHeader";

const { Content } = Layout;

class GameLayout extends React.Component<{}, {}> {

    public render() {
        return <Layout>
            <GeneralHeader
                renderEmulationBanner={true}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={false}
                renderPlanetBox={false}
                renderBackToSpaceStation={false}
            />
            <Layout className="has-side-nav">
                <GameSideNav />
                <Content style={{ overflowX: 'hidden' }}>
                    <div style={{ height: 'calc(100vh - 100px)' }}>
                        {this.props.children}
                    </div>
                </Content>
            </Layout>
        </Layout>;
    }
}

export default GameLayout;



// WEBPACK FOOTER //
// ./src/layouts/game/GameLayout.tsx